<template>
  <wizard-layout :id="this.step">
    <template>
      <wizard-box-left>
        <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>
        <wizard-header :title="this.title"></wizard-header>

        <div class="row">
          <wizard-button-step2 v-for="t in typologies" :key="t.value" :name="t.label" :isActive="typology == t.value" @onToggle="onToggle(t.value)"> </wizard-button-step2>
        </div>

        <wizard-footer :step="this.step" :display_next_button="display_next_button" :wizard_data="getWizardData" :user="this.user"> </wizard-footer>
      </wizard-box-left>
      <wizard-box-right :id="this.step">
        <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>
      </wizard-box-right>
    </template>
  </wizard-layout>
</template>

<script>
import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import WizardButtonStep2 from "@/Pages/Wizard/Elements/WizardButtonStep2";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import { redirectWizardSteps } from "@/helpers/helper";
import { typology_options } from "@/helpers/select-options";

export default {
  props: ["data", "user"],

  components: {
    WizardButtonStep2,
    WizardFooter,
    WizardHeader,
    WizardStep,
    WizardBoxLeft,
    WizardLayout,
    WizardBoxRight,
    WizardProgress,
  },

  computed: {
    display_next_button() {
      return this.fieldsAreEmpty();
    },

    getWizardData() {
      return {
        typology: this.typology,
      };
    },
  },

  data() {
    return {
      step: 2,
      header_step: 3,
      title: "La tipologia del tuo immobile",
      selectedIndex: null,
      progress: 1,
      progress_title: "Seleziona la tipologia del tuo immobile.",
      progress_description: "Scegli una fra le tipologie proposte e clicca su avanti.",
      typology: "",
      typologies: typology_options,
      //   typologies: [
      //     { value: 1, name: "Appartamento" },
      //     { value: 2, name: "Villa Indipendente" },
      //     { value: 3, name: "Attico" },
      //     { value: 4, name: "Loft/Open space" },
      //     { value: 5, name: "Mansarda" },
      //     { value: 6, name: "Villeta a schiera" },
      //   ],
    };
  },

  methods: {
    isAgency() {
      return this.user !== null && !window.location.href.includes("customer");
    },

    // getTypology(name) {
    //   var typology = this.typologies.filter((typology) => {
    //     return typology.name === name;
    //   });
    //   return typology[0].value;
    // },

    getTypology(typologyKey) {
      var typology = this.typologies.filter((typology) => {
        return typology.value === typologyKey;
      });
      return typology[0].value;
    },

    onToggle(typologyKey) {
      if (this.typology == typologyKey) {
        this.typology = null;
      } else {
        const typology = this.typologies.find((typology) => typology.value == typologyKey);
        if (typology) this.typology = typology.value;
      }
    },

    fieldsAreEmpty() {
      return this.typology !== "" && this.typology !== undefined;
    },
  },

  beforeMount() {
    redirectWizardSteps(this.isAgency(), this.step, "test", this.$inertia);

    let current_property = JSON.parse(localStorage.getItem("current_property"));

    if (current_property !== null) {
      this.typology = current_property.typology;
      this.selectedIndex = this.getTypology(current_property.typology);
    }
  },
};
</script>
